import { SET_ALIAS } from "./types";
import { getUserFromMidwayCredentials } from "../proxies/identityProxy";
import { credentials } from "../clients/OncallToolServiceClient";

export const setAlias = () => async dispatch => {
  const alias = await getUserFromMidwayCredentials(credentials);
  dispatch({
    type: SET_ALIAS,
    payload: alias
  });
};
